import { render, staticRenderFns } from "./ReOrderModal.vue?vue&type=template&id=18fcf6c2&scoped=true&lang=pug"
import script from "./ReOrderModal.vue?vue&type=script&lang=js"
export * from "./ReOrderModal.vue?vue&type=script&lang=js"
import style0 from "./ReOrderModal.vue?vue&type=style&index=0&id=18fcf6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcf6c2",
  null
  
)

export default component.exports